import styled from 'styled-components';
import { Flex } from '../../../../layout/Flex';

export const Wrapper = styled(Flex)
    .withConfig({ displayName: 'ContentPromotionDropdown' })
    .attrs<{ disabled?: boolean }>({
        width: '100%',
    })`
        ${(props) =>
            props.disabled &&
            `
            pointer-events: none;
            opacity: 0.5;
        `}
    `;
